import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { Estimate } from '@/models/Estimate';
import { EstimateModification } from '@/models/EstimateModification';

class EstimateService {
    public async sendAskEstimate(data: Estimate, documents: File[]): Promise<any> {
        const formData = new FormData();

        const transformToBlobJson = (data: any) => new Blob([JSON.stringify(data)], { type: 'application/json' });

        formData.set('demandeDevis', transformToBlobJson(data));

        const fileToBlob = async (file: File): Promise<Blob> => {
            return new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => reader.readAsBinaryString(file);
                resolve(file);
            });
        };

        await Promise.all(
            documents.map(async (file: File) => {
                const blob = await fileToBlob(file);
                formData.append('piecesJointes', blob, file.name);
            })
        );

        return http.post(Routes.DemandeDevisRoutes.PostAskEstimate(), formData);
    }
    public async updateAskEstimate(id: number, data: EstimateModification, documents: File[]): Promise<any> {
        const formData = new FormData();

        const transformToBlobJson = (data: any) => new Blob([JSON.stringify(data)], { type: 'application/json' });

        formData.set('demandeDevis', transformToBlobJson(data));

        const fileToBlob = async (file: File): Promise<Blob> => {
            return new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => reader.readAsBinaryString(file);
                resolve(file);
            });
        };

        await Promise.all(
            documents.map(async (file: File) => {
                const blob = await fileToBlob(file);
                formData.append('piecesJointes', blob, file.name);
            })
        );

        return http.post(Routes.DemandeDevisRoutes.PutDemandeDevis(id), formData);
    }

}

export default new EstimateService();
